import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "../../store/AuthStore";
const AdminRoute = ({ element }) => {
  const location = useLocation();
  const { user } = useAuthStore();
  
  // If not authenticated
  if (!user) {
    sessionStorage.setItem("redirectPath", location.pathname);
    return <Navigate to="/login" />;
  }

  // If authenticated but not admin
  if (!user.isAdmin) {
    return <Navigate to="/user/my-dashboard" replace />;
  }
  
  // If authenticated and admin
  return element;
};

export default AdminRoute;
